import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import CoachProgramsFilterBar from './CoachProgramsFilterBar'
import CoachProgramsList from './CoachProgramsList'
import { selectFilteredCategory, selectFiltersNumber } from '../../../reducers/groupProgramsReducer'
import NoPrograms from './EmptyProgramsList'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

const CoachProgramsCompletedTab = ({ fetchPrograms }) => {
  const { t } = useTranslation()
  const completed = useSelector(state => state.groupPrograms.completed)
  const filtersNumber = useSelector(state => selectFiltersNumber(state, completed.filters))
  const filteredCategory = useSelector(state => selectFilteredCategory(state, completed.filters?.categoryId))
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)

  return (
    <>
      <CoachProgramsFilterBar
        filters={completed.filters}
        filteredCategory={filteredCategory}
        filtersNumber={filtersNumber}
        search={completed.search}
        tab={'completed'}
      />
      {
        completed.programs.length > 0 ?
          <CoachProgramsList
            programs={completed.programs}
            timezone={timezone}
            hasMore={completed.hasMore}
            fetchPrograms={() => fetchPrograms(completed, 'completed')}
            status='completed'
          />
          :
          completed.hasMore === false ?
            (filtersNumber > 0 || completed.search) ? (
              <NoPrograms
                title={t('programs.common.noProgramsFound')}
                subtitle={t('programs.groups.noMatchClearFilters')}/>
            ) : (
              <NoPrograms
                title={t('programs.groups.completedTab.noCompletedPrograms')}
                subtitle={t('programs.groups.createPrompt')}/>
            ) : (
              <Loader message={t('programs.groups.loadingPrograms')} />
            )
      }
    </>
  )
}

CoachProgramsCompletedTab.propTypes = {
  fetchPrograms: PropTypes.func,
}

export default CoachProgramsCompletedTab
